import { Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-voyage-routes-segment',
  imports: [TranslateModule],
  templateUrl: './voyage-routes-segment.html',
})
export class VoyageRoutesSegment {
  addPortCall = output<void>();
  onAddPortCall(): void {
    this.addPortCall.emit();
  }
}
